import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil, last } from 'ramda';

import MembershipPresenter from '../../presenters/FastCash/MembershipPresenter';
import FormHeader from '../../components/FormHeader';
import Button from '../../components/Button';
import { VISIBILITY } from '../../constants/styles';
import { Flash } from '../../components';

import Membership from './components/Membership';
import GeneralInfo from './components/GeneralInfo';

const Memberships = (props) => {
  const {
    memberships,
    meta,
    apiErrors,
    onMembershipCreate,
    onMembershipUpdate,
  } = props;

  const currentMembership = last(memberships);
  const [response, setResponse] = useState({});

  const initialStateForVisibilityMemberships = memberships.reduce(
    (acc, membership) => ({ ...acc, [membership.id]: VISIBILITY.hidden }),
    {}
  );
  const [membershipsVisibility, setMembershipsVisibility] = useState(
    initialStateForVisibilityMemberships
  );

  const canCreateNewMembership =
    isEmpty(memberships) || MembershipPresenter.isArchived(currentMembership);

  const handleMembershipVisibilityChange = (membershipId) => () => {
    const currentVisibilityMembership = membershipsVisibility[membershipId];
    const isVisibleMembership =
      currentVisibilityMembership === VISIBILITY.visible;

    isVisibleMembership
      ? setMembershipsVisibility({
          ...membershipsVisibility,
          [membershipId]: VISIBILITY.hidden,
        })
      : setMembershipsVisibility({
          ...membershipsVisibility,
          [membershipId]: VISIBILITY.visible,
        });
  };

  useEffect(() => {
    if (!isNil(apiErrors)) {
      setResponse({ body: apiErrors });
    }
    return () => {
      setResponse({});
    };
  }, [apiErrors]);

  return (
    <div>
      <FormHeader title="Memberships">
        {canCreateNewMembership && (
          <Button
            className="button"
            onClick={onMembershipCreate}
            children="Create Membership"
          />
        )}
      </FormHeader>
      {!isEmpty(response) && (
        <Flash response={response.body} type={response.type} />
      )}
      {!isNil(currentMembership) && (
        <GeneralInfo meta={meta} currentMembership={currentMembership} />
      )}
      {isEmpty(memberships) ? (
        <div className="membership">
          <div className="membership-item">Memberships history is empty.</div>
        </div>
      ) : (
        <div>
          <div className="memberships-box">
            {memberships.map((membership) => (
              <Membership
                key={MembershipPresenter.id(membership)}
                membership={membership}
                membershipsVisibility={membershipsVisibility}
                onMembershipVisibilityChange={handleMembershipVisibilityChange}
                onMembershipUpdate={onMembershipUpdate}
                onResponseUpdate={setResponse}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Memberships;

Memberships.propTypes = {
  meta: PropTypes.shape().isRequired,
  memberships: PropTypes.arrayOf(MembershipPresenter.shape()),
  apiErrors: PropTypes.shape({}),
  onMembershipCreate: PropTypes.func.isRequired,
  onMembershipUpdate: PropTypes.func.isRequired,
};

Memberships.defaultProps = {
  apiErrors: {},
  memberships: [],
};
